
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Company() {
  const titleAnim = useScrollAnimation();
  const logoAnim = useScrollAnimation({ rootMargin: '0px 0px -60px 0px' });
  const infoAnim = useScrollAnimation({ rootMargin: '0px 0px -60px 0px' });

  return (
    <section id="company" className="py-12 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div
          ref={titleAnim.ref}
          className={`text-center mb-10 md:mb-16 ${titleAnim.isVisible ? 'anim-fade-up' : 'anim-hidden'}`}
        >
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-3 md:mb-4">
            企業情報
          </h2>
          <p className="text-xs md:text-sm text-gray-500 tracking-widest">
            Company
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div
            ref={logoAnim.ref}
            className={`flex justify-center ${logoAnim.isVisible ? 'anim-fade-left anim-delay-200' : 'anim-hidden'}`}
          >
            <img
              src="https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/4c9aba93a129479dba9f8478425c3679.png"
              alt="宝珠運輸ロゴ"
              className="max-w-[200px] md:max-w-xs w-full"
            />
          </div>

          <div
            ref={infoAnim.ref}
            className={`space-y-5 md:space-y-6 ${infoAnim.isVisible ? 'anim-fade-right anim-delay-300' : 'anim-hidden'}`}
          >
            <div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">
                宝珠運輸株式会社
              </h3>
              <p className="text-sm md:text-base text-gray-700 mb-2">
                〒497-0006 愛知県あま市七宝町下之森一丁田22番、23番
              </p>
              <a
                href="https://maps.app.goo.gl/uhMSREgzN7X6n3GB9"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center text-sm text-teal-500 hover:text-teal-600 font-medium cursor-pointer"
              >
                Google map
                <i className="ri-external-link-line ml-1"></i>
              </a>
            </div>

            <div className="border-t border-gray-200 pt-5 md:pt-6">
              <p className="text-sm md:text-base text-gray-700">
                <strong>MAIL:</strong> info@houjyu-logistics.jp
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
